var r="4.0.1";export{r as version};
//# sourceMappingURL=package.json.js.map
